import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faHeadset,
  faBook,
  faEnvelope,
  faPhone,
  faExternalLinkAlt
} from "@fortawesome/free-solid-svg-icons";

const SupportModal = ({ isOpen, onClose, t }) => {
  if (!isOpen) return null;

  return (
    <div
      className="subscription-modal__overlay subscription-modal__overlay--visible"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="subscription-modal__content">
        <div className="subscription-modal__header">
          <div className="subscription-modal__header-text">
            <h2>{t("navbar.help")}</h2>
            <span className="subscription-modal__header-plan">ProFisc</span>
          </div>
          <button className="subscription-modal__close" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="subscription-modal__body">
          <div className="support-modal__links">
            <a
              href="https://help.profisc.al"
              target="_blank"
              rel="noopener noreferrer"
              className="support-modal__link"
            >
              <div className="support-modal__link-icon">
                <FontAwesomeIcon icon={faBook} />
              </div>
              <div className="support-modal__link-info">
                <div className="support-modal__link-title">{t("navbar.helpCenter")}</div>
                <div className="support-modal__link-desc">help.profisc.al</div>
              </div>
              <FontAwesomeIcon icon={faExternalLinkAlt} className="support-modal__link-arrow" />
            </a>

            <a
              href="https://shop.profisc.al/sq/helpdesk/profisc-2"
              target="_blank"
              rel="noopener noreferrer"
              className="support-modal__link"
            >
              <div className="support-modal__link-icon">
                <FontAwesomeIcon icon={faHeadset} />
              </div>
              <div className="support-modal__link-info">
                <div className="support-modal__link-title support-modal__link-title--standalone">
                  {t("navbar.technicalAssistance")}
                </div>
              </div>
              <FontAwesomeIcon icon={faExternalLinkAlt} className="support-modal__link-arrow" />
            </a>

            <a
              href="mailto:fiskalizimi@profisc.al"
              className="support-modal__link"
            >
              <div className="support-modal__link-icon">
                <FontAwesomeIcon icon={faEnvelope} />
              </div>
              <div className="support-modal__link-info">
                <div className="support-modal__link-title">{t("navbar.email")}</div>
                <div className="support-modal__link-desc">fiskalizimi@profisc.al</div>
              </div>
            </a>

            <a
              href="tel:+355444528008"
              className="support-modal__link"
            >
              <div className="support-modal__link-icon">
                <FontAwesomeIcon icon={faPhone} />
              </div>
              <div className="support-modal__link-info">
                <div className="support-modal__link-title">{t("navbar.salesContact")}</div>
                <div className="support-modal__link-desc">+355 44 528 008</div>
              </div>
            </a>

            <a
              href="tel:+355444527999"
              className="support-modal__link"
            >
              <div className="support-modal__link-icon">
                <FontAwesomeIcon icon={faPhone} />
              </div>
              <div className="support-modal__link-info">
                <div className="support-modal__link-title">{t("navbar.supportContact")}</div>
                <div className="support-modal__link-desc">+355 44 527 999</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportModal;
